import { render } from "./DataExplorer.vue?vue&type=template&id=737850db"
import script from "./DataExplorer.vue?vue&type=script&lang=ts"
export * from "./DataExplorer.vue?vue&type=script&lang=ts"
script.render = render

export default script